import "./PaymentMethodCard.less";
import * as React from "react";
import { Amex, Mastercard, Visa } from "../../../static/creditCardBrands";
import { AtLink } from "../../../../../design-system";
import { AtMenuButton } from "../../AtMenuButton";
import { DeleteConfirmationAlert } from "../../Alerts";
import { DropdownItem } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GlobalStores, IStripeCustomerCard, ModalStore, ModalTypes, ProductBalanceStore } from "@atman/business";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { inject } from "mobx-react";

export interface IPaymentMethodCardProps {
    card: IStripeCustomerCard;
    modalStore?: ModalStore;
    productBalanceStore?: ProductBalanceStore;
}

const PaymentMethodCardComp: React.FC<IPaymentMethodCardProps> = (props) => {
    const { card } = props;

    const cardPresentationLabel = `${card.label} (**** **** **** ${card.last4Digits})`;
    let brandLogoUrl;

    switch (card.brand) {
        case "Visa":
            brandLogoUrl = Visa;
            break;
        case "MasterCard":
            brandLogoUrl = Mastercard;
            break;
        case "American Express":
            brandLogoUrl = Amex;
            break;
    }

    const openEditCardModal = () => props.modalStore!.openModal(ModalTypes.UpdateCard, { id: card.cardId });

    const openDeleteCardDialog = () =>
        new DeleteConfirmationAlert(
            () => props.productBalanceStore!.deleteCustomerCard(card.cardId),
            "global.deleteCustomerCardConfirmationText".localize(),
        ).fire();

    return (
        <div className="PaymentMethodCard">
            <div className="left-section">
                <img height={24} src={brandLogoUrl} alt={card.brand} className="card-logo" />
                <div className="card-info">
                    <div className="label">{cardPresentationLabel}</div>
                    <div className="expiration">{`${"global.expires".localize()} ${card.expMonth}/${card.expYear
                        .toString()
                        .slice(2, 4)}`}</div>
                </div>
            </div>
            <div className="right-section">
                <AtLink color={"secondary"} className="edit-card-information-link" onClick={openEditCardModal}>
                    {"global.editCardInformation".localize()}
                </AtLink>
                <AtMenuButton size={"md"}>
                    <DropdownItem onClick={openDeleteCardDialog}>
                        <span className="icon-container">
                            <FontAwesomeIcon icon={["far", "trash"] as IconProp} />
                        </span>
                        <span className="label">{"global.removeCard".localize()}</span>
                    </DropdownItem>
                </AtMenuButton>
                {/*<UncontrolledButtonDropdown>*/}
                {/*    <DropdownToggle>*/}
                {/*        <FontAwesomeIcon icon={"ellipsis-h"} />*/}
                {/*    </DropdownToggle>*/}
                {/*    <DropdownMenu>*/}
                {/*        <DropdownItem onClick={openDeleteCardDialog}>*/}
                {/*            <span className="icon-container">*/}
                {/*                <FontAwesomeIcon icon={[ 'far', 'trash' ] as IconProp} />*/}
                {/*            </span>*/}
                {/*            <span className="label">*/}
                {/*                { 'removeCard'.localize() }*/}
                {/*            </span>*/}
                {/*        </DropdownItem>*/}
                {/*    </DropdownMenu>*/}
                {/*</UncontrolledButtonDropdown>*/}
            </div>
        </div>
    );
};

const PaymentMethodCard = inject(GlobalStores.modalStore, GlobalStores.productBalanceStore)(PaymentMethodCardComp);

export { PaymentMethodCard };
